<template>
	<div>
		<div class="header">
			<div>
				<div style="display: flex; align-items: center; padding-top: 27px;">
					<div class="backIcon"><i class="cubeic-back" @click="$router.go(-1)"></i></div>
					<div style="font-size: 20px; color: black;
						font-weight: bold; display: flex;
						justify-content: center;
						margin-left: 10px;
						flex-grow: 0.88;
						align-items: center; height: 35px;">
					{{ storeInfo.store_name }}</div>
				</div>
				<div style="font-size: 13px; margin-right: 30px; color: white; font-weight: 100;"></div>
			</div>
		</div>
		<div class="content" style="height: calc(100vh - 200px);; overflow-y: scroll; padding: 90px 35px">
			<div class="card">
				<div style="display: flex; justify-content: space-between; align-items: center; color: #07111B;">
					<div style="color: #07111B; font-size: 13px; font-weight: bold;">{{ $t('order.goods_list') }}</div>
					<div style="font-size: 18px; font-weight: bold;">$ {{ totalPrice }}</div>
				</div>
				<div style="border: 1px solid #07111B; margin: 10px 0px;"></div>
				<div v-for="(goods, idx) in goodsList" :key="idx">
					<div class="listStyle" :style="[(idx == goodsList.length - 1)? {'border': 'none'} : {}]">
						<div style="font-size: 12px;">
							<span style="color: #07111B; margin-right: 10px">{{ goods.amount }}X</span>
							<span style="color: black">{{ goods.name }}</span>
						</div>
						<div style="font-size: 12px;">$ {{ utils.currencyPrice(goods.price) }}</div>
					</div>
				</div>
				<div style="border: 1px solid #07111B; margin: 10px 0px; margin-top: -20px;"></div>
				<div style="display: flex; justify-content: space-between; align-items: center; color: #646464; margin: 15px 0px;">
					<div style="font-size: 12px;">{{ $t('order.goods_price_total') }}</div>
					<div style="font-size: 12px;">$ {{ shopCart.total.foods }}</div>
				</div>
				<!-- <div style="display: flex; justify-content: space-between; align-items: center; color: #646464; margin: 10px 0px;">
					<div style="font-size: 12px;">
						10 元折價券
						<span style="color: #07111B; font-size: 12px; margin-left: 10px;">編輯</span>
					</div>
					<div style="font-size: 13px; color: #00A0DC">-$ 10</div>
				</div> -->
			</div>
			<div class="card">
				<div style="color: #07111B; font-size: 13px; font-weight: bold;">
					{{ $t('order.note') }}
				</div>
				<div style="border: 1px solid #07111B; margin: 10px 0px;"></div>
				<div style="display: flex; justify-content: space-between; align-items: center; color: #646464;">
					<div style="font-size: 12px; width: 30%">{{ $t('order.get_tableware') }}</div>
					<div style="font-size: 12px; width: 30%">{{ $t('order.tableware') }}</div>
					<div style="width: 30%; display: flex; justify-content: flex-end;">
						<cube-switch v-model="tablewareSwitch" class="switchStyle"></cube-switch>
					</div>
				</div>
				<div style="display: flex; justify-content: space-between; align-items: center; color: #646464; margin: 15px 0px 10px;">
										<div style="font-size: 12px; width: 30%">{{ $t('order.input_note') }}</div>
								</div>
								<div>
										<cube-textarea v-model.trim="note" class="inlineCard" :placeholder="$t('order.note_placeholder')"></cube-textarea>
								</div>
			</div>
		</div>
		<div class="footer">
				<div class="btnConfirm" @click="confirmPaymentHandler">
					<div style="font-size: 17px; font-weight: bold;">{{ $t('order.confirm_payment') }}</div>
					<div style="font-size: 17px; margin-left: 20px;">$ {{ $t('order.price_up', [utils.currencyPrice(totalPrice)]) }}</div>
				</div>
		</div>
	</div>
</template>

<script>
import { mapMutations } from 'vuex'
import { Toast } from 'mint-ui'
export default {
	name: 'step00',
	data() {
		return {
			tableware: false,
			noteInput: '',
		}
	},
	computed: {
		shopCart() {
			return this.$store.state.goodsdetail.shopCart
		},
		storeInfo() {
			return this.$store.state.goodsdetail.storeInfo
		},
		tablewareSwitch: {
			get() {
				return this.$store.state.goodsdetail.shopCart.tableware || this.tableware
			},
			set(value) {
				this.tableware = value
			}
		},
		note: {
			get() {
				return this.$store.state.goodsdetail.shopCart.note || this.noteInput
			},
			set(value) {
				this.noteInput = value
			}
		},
		totalPrice() {

			return this.shopCart.total.foods
		},
		goodsList() {
			let list = []
			this.shopCart.goods.forEach(goods => {
				list.push({amount: goods.goods_num, name: goods.goods_name, price: (goods.goods_price * goods.goods_num)})
				goods.gifts.forEach(gift => {
					list.push({amount: (gift.gift_amount * goods.goods_num), name: gift.gift_goodsname, price: 0})
				})
			})

			return list
		}
	},
	methods: {
		confirmPaymentHandler() {
			this.shopCart.note = this.noteInput
			this.shopCart.tableware = this.tableware
			this.$store.commit('setShopCart', this.shopCart)

			let cartIdTemp = []
			this.shopCart.goods.forEach((food) => {
				cartIdTemp.push(food.cart_id + '|' + food.store_id)
			})
			let cartId = cartIdTemp.join(',')

			this.$router.push({ name: 'MemberBuyStep01', query: { cart_id: cartId } })
		},
	}
}
</script>

<style scoped>
	.header {
		position: fixed;
		top: 0px;
		width: 100%;
		height: 65px;
		background-color: #f4c41e;
		box-shadow: 0px 2px 8px 2px darkgrey;
		padding: 8px 0px;
		z-index: 2;
		border-radius: 0 0 30px 30px;
	}
	.header .fl{margin-left:.5rem;}
	.header .fl em{line-height:2rem;display: block;}
	.footer {
		position: fixed;
		bottom: 0;
		width: 100%;
		height: 70px;
		background-color: #f4c41e;
		box-shadow: 0 4px 10px 5px darkgrey;
		z-index: 2;
	}
	.btnConfirm {
		margin: 15px;
		display: flex;
		justify-content: center;
		background-color: #DD2C35;
		border-radius: 30px;
		color: white;
		align-items: center;
		padding: 13px 20px;
		box-shadow: 0px 2px 0px 0px #B22433;
	}
	.backIcon {
		/* background: white; */
		width: 30px;
		height: 30px;
		display: flex;
		justify-content: center;
		align-items: center;
		border-radius: 50%;
		font-size: 18px;
	}
	.selectStyle {
		height: 30px;
		border: none;
		width: auto;
		border: 1px solid black;
		display: flex;
		justify-content: center;
		align-items: center;
		background-color: white;
		color: black;
		border-radius: 12px;
	}
	.card {
		margin: 20px -20px;
		border: 1px solid darkgray;
		box-shadow: 0px 1px 8px rgb(8, 6, 6);
		padding: 15px;
		border-radius: 10px;
	}
	.inlineCard {
		font-size: 12px;
		line-height: 16px;
		color: #B0AEAE;
		border: 2px solid #E1E1E1;
		border-radius: 6px;
	}
	.inlineCard >>> .cube-textarea {
				background-color: transparent !important;
		}
	.listStyle {
		display: flex;
		justify-content: space-between;
		margin: 20px 0px;
		border-bottom: 1px solid darkgray;
		padding-bottom: 15px;
		align-items: center;
		color: #646464;
	}
	.switchStyle {
		height: 28px;
		width: 40px;
	}
	.switchStyle >>> .cube-switch-ui {
		width: 45px;
		height: 20px;
	}
	.switchStyle >>> .cube-switch-ui::after {
		width: 20px;
	}
</style>
